export const AVAILABILITY_PER_TIME_UNITS = [
    'hoursPerDay', 'hoursPerWeek', 'daysPerWeek', 'hoursPerMonth', 'daysPerMonth'
];
